<template>
  <div id="homePage">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script setup lang="ts">
const msg = "欢迎来到搭配学习进取生活，你将从这里开始项目学习之旅~";
</script>

<style scoped>
#homePage {
}
</style>
